//프로젝트별 수주품의서 히스토리
import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';

const [
  LIST_ORDER_LETTERS,
  LIST_ORDER_LETTERS_SUCCESS,
  LIST_ORDER_LETTERS_FAILURE,
] = createRequestActionTypes('project/LIST_ORDER_LETTERS');
export const listOrderLetters = createAction(LIST_ORDER_LETTERS, (id) => id);
const listOrderLettersSaga = createRequestSaga(
  LIST_ORDER_LETTERS,
  projectApi.getProjectOrderHistory,
);

const UNLOAD_ORDER_LETTERS = 'project/UNLOAD_ORDER_LETTERS';
export const unloadOrderLetters = createAction(UNLOAD_ORDER_LETTERS);

export function* orderLettersSaga() {
  yield takeLatest(LIST_ORDER_LETTERS, listOrderLettersSaga);
}

const initialState = {
  orderLetters: null,
  error: null,
};

const orderLetters = handleActions(
  {
    [LIST_ORDER_LETTERS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      orderLetters: data.list.map((orderLetter) => ({
        id: orderLetter.roUuid,
        roUuid: orderLetter.roUuid,
        roNo: orderLetter.roNo,

        partnerUuid: orderLetter.partnerUuid,
        partnerNm: orderLetter.partnerNm,
        employeeUuid: orderLetter.employeeUuid,
        employeeNm: orderLetter.employeeNm,
        partnerInc: orderLetter.partnerInc,
        chargeNm: orderLetter.chargeNm,
        salesUuid: orderLetter.salesUuid,
        salesNm: orderLetter.salesNm,
        expDay: orderLetter.expDay,
        siDt: orderLetter.siDt,
        mtnFreeTm: orderLetter.mtnFreeTm,
        mtnFreeStrtDt: orderLetter.mtnFreeStrtDt,
        mtnFreeEndDt: orderLetter.mtnFreeEndDt,
        collCondt: orderLetter.collCondt,
        payCondt: orderLetter.payCondt,
        ordYn: orderLetter.ordYn,
        crtNm: orderLetter.crtNm,
        crtDt: orderLetter.crtDt,
        cngNm: orderLetter.cngNm,
        cngDt: orderLetter.cngDt,
      })),
      error: null,
    }),
    [LIST_ORDER_LETTERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_ORDER_LETTERS]: () => initialState,
  },
  initialState,
);

export default orderLetters;
